import Core from '../plugin-core-system/core.class.js';

export default class CsCountrySelection extends Core {
  static options = {};

  selectedCountry = null;

  init() {
    this.list = this.el.querySelector('.js-country-selection-list');
    this.svgMap = this.el.querySelector('.js-country-selection-map');
    this.mapImage = this.svgMap?.querySelector('img');

    if (!this.list || !this.svgMap) {
      return;
    }

    this.setMapLinkTargets();
    this.setInitialCountry();
    this.registerEvents();
  }

  getListLinks() {
    return this.list.querySelectorAll('a[data-country-id]');
  }

  getMapLinks() {
    return this.svgMap.querySelectorAll('a[data-country-id]');
  }

  getListLinkByCountryId(countryId) {
    return this.list.querySelector(`a[data-country-id="${countryId}"]`);
  }

  getMapLinkByCountryId(countryId) {
    return this.svgMap.querySelector(`a[data-country-id="${countryId}"]`);
  }

  setMapLinkTargets() {
    this.getMapLinks().forEach((mapLink) => {
      const countryId = mapLink.dataset.countryId;
      const listLink = this.getListLinkByCountryId(countryId);
      const href = listLink?.getAttribute('href');

      if (!href) {
        return;
      }

      mapLink.setAttribute('href', href);
      mapLink.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', href);
    });
  }

  setInitialCountry() {
    const activeLink = this.list.querySelector('a.root-active');

    if (!activeLink) {
      return;
    }

    this.changeCountry(activeLink.dataset.countryId);
  }

  changeCountry(countryId) {
    if (!countryId) {
      return;
    }

    if (this.selectedCountry !== null) {
      this.getListLinkByCountryId(this.selectedCountry)?.classList.remove('active');
      this.getMapLinkByCountryId(this.selectedCountry)?.classList.remove('active');

      if (this.mapImage) {
        this.mapImage.style.visibility = 'hidden';
      }
    }

    this.selectedCountry = countryId;

    this.getListLinkByCountryId(countryId)?.classList.add('active');
    this.getMapLinkByCountryId(countryId)?.classList.add('active');

    if (String(countryId) === '167' && this.mapImage) {
      this.mapImage.style.visibility = 'visible';
    }
  }

  registerEvents() {
    this.getListLinks().forEach((link) => {
      link.addEventListener('mouseenter', (event) => {
        this.changeCountry(event.currentTarget.dataset.countryId);
      });
      link.addEventListener('focus', (event) => {
        this.changeCountry(event.currentTarget.dataset.countryId);
      });

    });

    this.getMapLinks().forEach((link) => {
      link.addEventListener('mouseenter', (event) => {
        this.changeCountry(event.currentTarget.dataset.countryId);
      });
      link.addEventListener('focus', (event) => {
        this.changeCountry(event.currentTarget.dataset.countryId);
      });
    });
  }
}
